import {
  GET_NOTIFICATIONRESPONSIBLE_FAIL,
  GET_NOTIFICATIONRESPONSIBLE_SUCCESS,
  GET_NOTIFICATIONRESPONSIBLES_FAIL,
  GET_NOTIFICATIONRESPONSIBLES_SUCCESS,
  ADD_NOTIFICATIONRESPONSIBLE_SUCCESS,
  ADD_NOTIFICATIONRESPONSIBLE_FAIL,
  UPDATE_NOTIFICATIONRESPONSIBLE_SUCCESS,
  UPDATE_NOTIFICATIONRESPONSIBLE_FAIL,
  DELETE_NOTIFICATIONRESPONSIBLE_SUCCESS,
  DELETE_NOTIFICATIONRESPONSIBLE_FAIL,  
  SET_STATE_NOTIFICATIONRESPONSIBLE
} from "./actionTypes";

const INIT_STATE = {
  notificationResponsibles: [],
  notificationResponsible: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const notificationResponsibles = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONRESPONSIBLES_SUCCESS:
      return {
        ...state,
        notificationResponsibles: action.payload.notificationResponsibles,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_NOTIFICATIONRESPONSIBLE:
      return { ...state, loading: action.payload }

    case GET_NOTIFICATIONRESPONSIBLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_NOTIFICATIONRESPONSIBLE_SUCCESS:
      return {
        ...state,
        notificationResponsibles: [...state.notificationResponsibles, action.payload],
      };

    case ADD_NOTIFICATIONRESPONSIBLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_NOTIFICATIONRESPONSIBLE_SUCCESS:
      return {
        ...state,
        notificationResponsibles: state.notificationResponsibles.map(notificationResponsible =>
          notificationResponsible.id.toString() === action.payload.id.toString()
            ? { ...action.payload, notificationResponsible }
            : notificationResponsible
        ),
      };

    case UPDATE_NOTIFICATIONRESPONSIBLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_NOTIFICATIONRESPONSIBLE_SUCCESS:
      return {
        ...state,
        notificationResponsibles: state.notificationResponsibles.filter(
          notificationResponsible => notificationResponsible.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_NOTIFICATIONRESPONSIBLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_NOTIFICATIONRESPONSIBLE_SUCCESS:
      return {
        ...state,
        notificationResponsible: action.payload,
      };

    case GET_NOTIFICATIONRESPONSIBLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default notificationResponsibles;
